<template>
  <div>
    <v-card flat>
      <v-row class="mx-5">
        <v-col cols="12" md="6" class="pb-0">
          <v-autocomplete
            background-color="#F6F8FC"
            label="Choose a category"
            attach
            flat
            dense
            solo
            v-model="form.SubcategoryId"
            :items="category"
            item-text="name"
            item-value="id"
            :error-messages="
              $v.form.SubcategoryId.$error ? 'Category is required' : null
            "
          />
        </v-col>
      </v-row>
      <!-- <v-row class="mx-5">
        <v-col cols="12" md="6" class="pb-0">
          <v-file-input
            v-model="form.File"
            background-color="#F6F8FC"
            label="Choose a File"
            flat
            dense
            solo
            :show-size="showSize"
            @change="showSize = true"
            variant="solo-filled"
            accept="image/*,video/*"
            :error-messages="
              $v.form.File.$error
                ? 'File is required'
                : form.File && form.File.size > 2 * 1024 * 1024
                ? 'File size exceeds the 2MB limit'
                : null
            "
          />
        </v-col>
      </v-row> -->
      <v-row class="mx-5">
        <v-col cols="12" class="py-0">
          <b>Post Title</b>
        </v-col>
      </v-row>
      <v-row class="mx-5">
        <v-col cols="12" md="8">
          <v-textarea
            rows="2"
            :rules="limitTitle"
            name="input-7-1"
            outlined
            counter="100"
            single-line
            v-model="form.Title"
            :error-messages="$v.form.Title.$error ? 'Title is required' : null"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row class="mx-5">
        <v-col cols="12">
          <vue-editor
            useCustomImageHandler
            @image-added="handleImageAdded"
            @image-removed="handleImageRemove"
            v-model="form.content"
            class="forumcustomEditor"
            ref="contentForum"
          ></vue-editor>
          <div v-if="$v.form.content.$error" class="mt-1 error--text">
            Description is required
          </div>
        </v-col>
      </v-row>
      <v-card-actions class="pb-4 mx-5 py-9">
        <v-spacer></v-spacer>
        <v-btn color="grey lighten-1" text @click="close"> </v-btn>
        <v-btn
          :disabled="btnloader"
          depressed
          color="primary"
          class="px-14"
          @click="save"
        >
          <span v-if="btnloader != true"> Post </span>
          <v-progress-circular
            indeterminate
            v-else
            size="20"
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  name: "EditForumComponent",
  props: ["editItem"],
  components: {
    VueEditor,
  },
  computed: {
    ...mapGetters(["GetLoggedInUser", "GetForumCategories"]),
  },
  data() {
    return {
      showSize: false,
      form: {
        Id: "",
        Title: "",
        ImgVid: "",
        File: {
          name: "",
        },
        SubcategoryId: "",
        Visibility: true,
        Pinned: false,
        SubmittedBy: "",
        content: "",
        OriginalContent: "",
      },
      limitTitle: [(v) => v.length <= 300 || "Max 300 characters"],
      tab: "",
      svgBackground: true,
      UploadedImage: false,
      SingleImage: {},
      img: {},
      cropper: {},
      destination: {},
      btnloader: false,
      Src: null,
      Type: null,
      category: [],
      content: "",
    };
  },
  validations: {
    form: {
      SubcategoryId: {
        required,
      },
      Title: {
        required,
      },
      // File: {
      //   required,
      // },
      content: {
        required,
      },
    },
  },
  mounted() {
    if (this.editItem.ImgVid) {
      this.form.File.name = this.editItem.ImgVid.split("_").slice(-1)[0];
    }
    this.form.SubmittedBy = this.GetLoggedInUser.Id;
    this.form.SubcategoryId = this.editItem.SubcategoryId;
    this.form.Title = this.editItem.Title;
    this.form.content = this.editItem.Description;
    this.form.Id = this.editItem.Id;
    let arr = [];
    this.GetForumCategories.forEach((category) => {
      arr.push({
        header: category.Name,
      });
      category?.Subcategories.forEach((subcat) => {
        arr.push({
          name: subcat.SubCategoryName,
          id: subcat.Id,
        });
      });
    });
    this.category = arr;
  },
  methods: {
    sanitizeFileName(originalName) {
      const extension = originalName.substring(originalName.lastIndexOf('.') + 1);
      const baseName = originalName.substring(0, originalName.lastIndexOf('.'));

      const safeBaseName = baseName.replace(/[^a-zA-Z0-9_-]/g, '_');
      return `${safeBaseName}.${extension}`;
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      const sanitizedFile = new File(
        [file], 
        this.sanitizeFileName(file.name), 
        { type: file.type }
      );
      
      this.$store.dispatch("UploadForumImage", sanitizedFile).then((bucketUrl) => {
        Editor.insertEmbed(cursorLocation, "image", bucketUrl);
        // Move cursor after the image for better UX
        const quill = this.$refs.contentForum.quill;
        const currentIndex = quill.getSelection().index;
        const newPosition = currentIndex + 1;
        quill.setSelection(newPosition);
        resetUploader();
      });
    },
    handleImageRemove(file) {
      if (file && typeof file === 'object' && file.src) {
        this.$store.dispatch("DeleteForumImage", file);
      }
    },
    extractImagePath(bucketUrl) {
      try {
        const url = new URL(bucketUrl);
        let path = url.pathname;
        
        if (path.startsWith('/')) {
          path = path.substring(1);
        }
        
        // Decode URL entities first
        const decodedPath = path
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#039;/g, "'");
        
        return decodedPath;
      } catch (error) {
        console.error('Error parsing URL:', error);
        if (bucketUrl.startsWith('/')) {
          return bucketUrl.substring(1);
        }
        return bucketUrl;
      }
    },

    convertContentForAPI(content) {
      if (!content) return content;
      
      let convertedContent = content;
      
      // Find all image tags and replace bucket URLs with just image paths
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      
      convertedContent = convertedContent.replace(imgRegex, (match, srcUrl) => {
        // Decode URL entities in src URL
        const decodedUrl = srcUrl
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&#039;/g, "'");
        
        const imagePath = this.extractImagePath(decodedUrl);
        return match.replace(srcUrl, imagePath);
      });
      
      return convertedContent;
    },
    save() {
      this.$v.form.$touch();
      if (
        this.$v.form.$invalid ||
        (this.form.File && this.form.File.size > 2 * 1024 * 1024)
      ) {
        return;
      } else {
        this.form.Status = 1;
        this.btnloader = true;
        var Form = new FormData();
        const ContentWithoutBucketPaths = this.convertContentForAPI(this.form.content);
        Form.append("Status", "Published");
        Form.append("Description", ContentWithoutBucketPaths);
        Form.append("Title", this.form.Title);
        Form.append("SubcategoryId", this.form.SubcategoryId);
        if (this.showSize) {
          Form.append("ImgVidFile", this.form.File);
        }
        Form.append("Visibility", true);
        Form.append("Pinned", false);
        Form.append("SubmittedBy", this.form.SubmittedBy);
        Form.append("Id", this.form.Id);
        this.btnloader = true;

        this.$store.dispatch("EditForum", Form).then((res) => {
          if (res.Status) {
            this.close();
            this.$emit("savePost");
          }
          this.btnloader = false;
        });
      }
    },

    resetForm() {
      this.form.Title = "";
      this.form.Description = "";
      this.form.ImgVidFile = "";
      this.form.SubcategoryId = "";
      this.content = "";
      this.btnloader = false;
      this.$refs.Img.value = "";
      this.Src = null;
      this.Type = null;
    },
    close() {
      this.$emit("close");
    },

    UploadImg() {
      this.$refs.Img.click();
    },
    SetImage() {
      this.Src = null;
      var reader = new FileReader();

      reader.onload = () => {
        if (!this.$refs.Img.files[0].type.includes("video")) {
          this.Type = "Image";
          this.Src = reader.result;
          this.$refs.Image.src = reader.result;
        } else {
          this.Src = reader.result;
          this.Type = "Video";
        }
      };
      this.form.ImgVidFile = this.$refs.Img.files[0];
      reader.readAsDataURL(this.$refs.Img.files[0]);
    },
  },
};
</script>

<style scoped>
.tabs_style {
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0em;
}
.forumcustomEditor img {
  width: 600px !important;
  height: auto;
  display: block;
  margin: 10px 0px;
}
a:hover {
  text-decoration: none;
}
.v-tabs-slider {
  background-color: white !important;
}
.h1_tab2 {
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 500;
  line-height: 26px;
}
.content_span {
  font-family: " DM Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}
.content_date {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.38);
}
.content_chip {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #54be5a;
}
#no-background-hover::before {
  background-color: transparent !important;
}
</style>
